import { render, staticRenderFns } from "./AreasModule.vue?vue&type=template&id=88cd1332"
import script from "./AreasModule.vue?vue&type=script&lang=js"
export * from "./AreasModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports